const queue = [];
let container = null;

function getContainer() {
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }
  return container;
}

export function showToast(message, type = 'info', duration = 3500) {
  const c = getContainer();
  const toast = document.createElement('div');
  toast.className = `toast-${type}`;

  const icons = { success: 'fa-circle-check', error: 'fa-circle-xmark', warning: 'fa-triangle-exclamation', info: 'fa-circle-info' };
  toast.innerHTML = `<i class="fa-light ${icons[type] || icons.info}"></i><span>${message}</span>`;

  c.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('opacity-0', 'translate-y-[-8px]', 'transition-all', 'duration-300');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

export function initToast() {
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-toast]');
    if (!btn) return;
    const { toast: msg, toastType: type = 'info' } = btn.dataset;
    showToast(msg, type);
  });
}
